module.exports = __webpack_public_path__ + "img/icon_sort_asc_active.e88ddab2.svg";